<template>
  <div>
    <div class="ResourcePermission-title">
      <Breadcrumb>
        <BreadcrumbItem to="/permissionsConfigurationManagement/group">{{
          $t("permission_configuration_management.group.accessConfiguration")
        }}</BreadcrumbItem>
        <BreadcrumbItem>{{ groupName }}</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <template>
      <Tabs
        size="small"
        :value="currentTab"
        @on-click="currentTabChanged"
        :animated="false"
      >
        <TabPane
          :label="$t('permission_configuration_management.group.user')"
          name="user"
        >
          <add-users></add-users>
        </TabPane>
        <TabPane
          :label="$t('permission_configuration_management.group.account')"
          name="account"
        >
          <add-account ref="accountChild"></add-account>
        </TabPane>

        <!-- 整合下面的所有资源 -->
        <TabPane label="资源" name="resource">
          <resource />
        </TabPane>
        <!-- <TabPane :label="$t('permission_configuration_management.group.instance')" name="instance">
                  <add-instances ref="instanceChild"></add-instances>
              </TabPane>
              <TabPane :label="$t('permission_configuration_management.group.disks')" name="volume">
                  <add-volumes ref="volumeChild"></add-volumes>
              </TabPane>
              <TabPane :label="$t('permission_configuration_management.group.database')" name="database">
                  <add-databases ref="databaseChild"></add-databases>
              </TabPane>
              <TabPane :label="$t('permission_configuration_management.group.storageGateway')" name="storageGateway">
                <add-storage-gateways ref="storageGatewayChild"></add-storage-gateways>
              </TabPane> -->
        <!--              <TabPane :label="$t('permission_configuration_management.group.virtualDesktop')" name="workSpace">-->
        <!--                  <add-work-space ref="workSpaceChild"></add-work-space>-->
        <!--              </TabPane>-->
        <!-- <TabPane label="Redis" name="elastiCache">
                <add-elasti-cache ref="elastiCacheChild"></add-elasti-cache>
              </TabPane> -->
      </Tabs>
    </template>
  </div>
</template>

<script>
import { getCookie } from "../../../../utils/cookieUtil.js";
import AddInstances from "../resource_permission/AddInstances";
import AddDatabases from "../resource_permission/AddDatabases";
import AddVolumes from "../resource_permission/AddVolumes";
import AddAccount from "../resource_permission/AddAccount";
import AddUsers from "../resource_permission/AddUsers";
import AddWorkSpace from "../resource_permission/AddWorkSpace";
import AddStorageGateways from "../resource_permission/AddStorageGateways";
import AddElastiCache from "../resource_permission/AddElastiCache";

import resource from "./resource/resource.vue";

export default {
  name: "ResourcePermission",
  components: {
    AddInstances,
    AddDatabases,
    AddUsers,
    AddVolumes,
    AddAccount,
    AddWorkSpace,
    AddStorageGateways,
    AddElastiCache,

    resource
  },
  data() {
    return {
      currentName: "",
      groupName: "",
      currentTab: "",
      tabName: "user",
      to: {
        path: "/permissionsConfigurationManagement/group"
      }
    };
  },
  mounted: function() {
    this.init();
  },
  methods: {
    init: function() {
      this.id = this.$route.query.id;
      this.currentName = getCookie(global.cookieName);
      // 获取详情数据
      this.$api.group.selectGroup("id", this.id).then(res => {
        this.groupName = res.data.name;
      });
    },
    // 根据相应的tab名 调它下面相应的方法
    currentTabChanged(name) {
      this.tabName = name;
      if (this.tabName == "instance") {
        this.$refs.instanceChild.queryInstancesByGroupId();
        this.$refs.instanceChild.queryCloudPlatforms();
      } else if (this.tabName == "account") {
        this.$refs.accountChild.queryAccountByGroupId();
      } else if (this.tabName == "volume") {
        this.$refs.volumeChild.queryCloudPlatforms();
        this.$refs.volumeChild.queryVolumesByGroupId();
      } else if (this.tabName == "database") {
        this.$refs.databaseChild.getAccountType();
        this.$refs.databaseChild.queryDatabaseEngines();
        this.$refs.databaseChild.queryDatabasesByGroupId();
      } else if (this.tabName == "workSpace") {
        this.$refs.workSpaceChild.selectAccount();
        this.$refs.workSpaceChild.queryWorkspacesByGroupId();
      } else if (this.tabName == "storageGateway") {
        this.$refs.storageGatewayChild.queryCloudPlatforms();
        this.$refs.storageGatewayChild.queryStorageGatewaysByGroupId();
      } else if (this.tabName == "elastiCache") {
        this.$refs.elastiCacheChild.queryCloudPlatforms();
        this.$refs.elastiCacheChild.pagingQuery();
      }
    }
  }
};
</script>

<style scoped>
/*ResourcePermission*/
.ResourcePermission-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 15px 4px;
  font-weight: 600;
}
.ivu-breadcrumb {
  font-size: 13px;
  font-weight: 600;
  color: #515a6e;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/resource_permission/ResourcePermission.vue